module.exports = __webpack_public_path__ + "img/1f40d.990192a.svg";